import TagManager from "react-gtm-module";

let initialized = false;
let currentUserId: string | null = null;

function getDataLayerName(): string {
  return process.env.REACT_APP_GTM_DATA_LAYER_NAME?.trim() || "dataLayer";
}

export function initGTM(): void {
  const gtmId = process.env.REACT_APP_GTM_ID?.trim();
  if (typeof window === "undefined" || !gtmId || initialized) {
    return;
  }

  TagManager.initialize({
    gtmId,
    dataLayerName: getDataLayerName(),
    dataLayer: {
      product: "Creator Platform MVP",
      analytics_schema: "mvp_aarrr_v1",
    },
  });

  initialized = true;
}

export function isGTMInitialized(): boolean {
  return initialized;
}

export function setGTMUserId(userId: string | null | undefined): void {
  currentUserId = userId ? String(userId) : null;
}

export function getGTMUserId(): string | null {
  return currentUserId;
}

export function pushGTMEvent(payload: Record<string, unknown>): void {
  if (!initialized) {
    return;
  }

  TagManager.dataLayer({
    dataLayerName: getDataLayerName(),
    dataLayer: payload,
  });
}
